"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyUploadFileItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Button_1 = __importDefault(require("../Button"));
var styles_1 = require("./styles");
var EmptyUploadFileItem = function (_a) {
    var uploadNameLabel = _a.uploadNameLabel, uploadButtonLabel = _a.uploadButtonLabel, onFileSelected = _a.onFileSelected, inputAccept = _a.inputAccept, isMobile = _a.isMobile, iconJsx = _a.iconJsx;
    var inputRef = (0, react_1.useRef)(null);
    var handleFileInputClick = function () {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };
    var handleFileSelected = function (e) {
        if (e.target.files && e.target.files.length > 0 && onFileSelected) {
            onFileSelected(e.target.files[0]);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, { children: [iconJsx, (0, jsx_runtime_1.jsx)(styles_1.Content, { children: (0, jsx_runtime_1.jsx)(styles_1.BodyTitle, __assign({ "data-testid": "upload-file-uploadnamelabel" }, { children: uploadNameLabel })) }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: handleFileInputClick, variant: "primary", size: isMobile ? 'sm' : 'md', "data-testid": "upload-file-button" }, { children: uploadButtonLabel })), (0, jsx_runtime_1.jsx)("input", { ref: inputRef, type: "file", name: "file", accept: inputAccept, style: { display: 'none' }, onChange: handleFileSelected, "data-testid": "empty-upload-file-input" })] }));
};
exports.EmptyUploadFileItem = EmptyUploadFileItem;
